import React, { Component } from "react";
import {logout} from '../../utils/BeeApi';
import { logout as DeLogout } from "../../utils/DeApi"; 
import { Alert } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import "./ErrorHandler.css";
class ErrorHandler extends Component {

  constructor(props){
    super(props);
    this.state = {
      logOut: false,
      logoutError: ""
    }
  }
/* *** loggin-out user *** */
  triggerLogout(){
    logout().then((response) => {
      return DeLogout();
    }).then((data) => {
      this.setState({
        logOut: true
      });
    }).catch((error) => {
      this.setState({
        logoutError: error.status + ": " + error.statusText,
        logOut: false
      });
    });
  }

  render() {
    const error = this.props.error;
    let status = "";
    let statusText = "Oh snap! You got an error!";
    let message = "Something unexpected happened. Please try again.";
    let currentRoute = window.location.pathname;

    if (error) {
      status = error.status || status;
      statusText = error.statusText || statusText;
      if (error.data && error.data.error) {
        message = error.data.error.message || message;
      }
    }

    /* *** redirecting user if status is 401 and user is not already to the login page *** */
    if( status === 401 && currentRoute !== '/login' ){
      this.triggerLogout();
    }

    return (!this.state.logOut) ? (
      <Alert variant="warning" className="mt-md mb-md">
        <Alert.Heading>{statusText}</Alert.Heading>
        <p>{this.props.message || message}</p>
        <small>{status}</small>
      </Alert>
    ) : <Redirect to="/login" />;
  }
}

export default ErrorHandler;
